import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Success from "@/pages/Success";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import { LanguageProvider } from "@/lib/i18n";
import { AdminAuthProvider } from "@/lib/admin-auth";
import { initAnalytics } from "@/lib/analytics";

function App() {
  useEffect(() => {
    initAnalytics();
  }, []);

  return (
    <LanguageProvider>
      <AdminAuthProvider>
        <div className="App bg-[#0A0A0A] text-[#F5F5F0] min-h-screen">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/success" element={<Success />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
          </BrowserRouter>
          <Toaster
            theme="dark"
            position="bottom-right"
            toastOptions={{
              style: {
                background: "#111111",
                border: "1px solid #2A2A2A",
                color: "#F5F5F0",
              },
            }}
          />
        </div>
      </AdminAuthProvider>
    </LanguageProvider>
  );
}

export default App;
